import { HttpParameterCodec, HttpParams } from '@angular/common/http';
import { TablePageSortAndFilter } from './table-page-sort-and-filter';

/**
 * Bietet statische Methoden zum Estellen von URL Parameter aus dem TablePageSortAndFilter an.
 *
 * @author femu
 */
export class TableHttpClientUrlParamsUtil {

    static FILTER: string = 'Filter';

    /**
     * Erstellt die HttpParams Parameter aus dem Objekt TablePageSortAndFilter für den HttpClient Service.
     * Diese werden für die zweite Version der Anfrage einer paginierten Tabellenergebnisses benötigt:
     *  - dabei werden die Filter einzeln als Parameter übertragen und nicht als ein generischens Array
     *  - für Filter gelten folgende Namens-Konventionen:
     *      - normale Filter: "<name der property>Filter"
     *      - Datumsfilter: "<name der property>FromFilter oder <name der property>ToFilter"
     *  - die Sortierung wird in einem sort Attribut übertragen, so wie von Spring MVC erwartet, damit aus
     *    size, page und sort automatisch ein Pageable Object erzeugt werden kann
     */
    static getHttpParams(info: TablePageSortAndFilter, encoder?: HttpParameterCodec): HttpParams {
        let params: HttpParams = new HttpParams({ encoder: encoder });
        if (info.size) {
            params = params.append('size', info.size.toString());
        }
        if (info.page) {
            params = params.append('page', info.page.toString());
        }

        if (info.sortProperty && info.sortDirection) {
            params = params.append('sort', info.sortProperty + ',' + info.sortDirection);
        }

        info.filter.filter(f => !!f.value).forEach(filter => {
            if (typeof filter.value !== 'string' && typeof filter.value !== 'number' && !(filter.value instanceof Date)) {
                // Der Filterwert ist ein Objekt. Es wird für jede Property des Objektes ein HTTP-Query-Parameter erzeugt.
                // z.B. für from und to bei Datums-Bereichs-Filtern.
                Object.getOwnPropertyNames(filter.value).forEach((propertyName) => {
                    // Der Name des HTTP-Params ist {filterName}{propertyName}Filter in Camelcase.
                    const paramName = filter.name + propertyName.charAt(0).toUpperCase() + propertyName.substr(1).toLowerCase();
                    const value = filter.value[propertyName];
                    if (value !== undefined && value !== null) {
                        params = params.append(paramName + 'Filter', this.convertSingleValue(value));
                    }
                });
            } else {
                params = params.append(filter.name + 'Filter', this.convertSingleValue(filter.value));
            }
        });
        return params;
    }

    private static convertSingleValue(value: string | number | Date) {
        if (value instanceof Date) {
            return value.toISOString();
        } else {
            return value.toString();
        }
    }
}
